// PDP redesign behaviours. One file, no deps. Modules init only if their DOM exists.
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const money = (cents) =>
    new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(cents / 100).replace(/\.00$/, "");

  function initGallery() {
    const hero = $("[data-hero]");
    if (hero) {
      $$("[data-thumb]").forEach((t) =>
        t.addEventListener("click", () => {
          const tpl = document.getElementById(t.dataset.media);
          if (tpl) hero.innerHTML = tpl.innerHTML;
          $$("[data-thumb]").forEach((x) => x.classList.toggle("is-active", x === t));
        })
      );
      $("[data-thumbs-more]")?.addEventListener("click", () => $("[data-thumbs]").classList.add("is-expanded"));
    }
    const track = $("[data-mob-gallery]");
    const dots = $$("[data-dots] .pdp-dot");
    if (track && dots.length) {
      track.addEventListener("scroll", () => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach((d, j) => d.classList.toggle("is-active", j === i));
      }, { passive: true });
    }
  }

  function initLightbox() {
    const box = $("[data-lightbox]");
    const triggers = $$("[data-expand]");
    if (!box || !triggers.length) return;
    document.body.appendChild(box); // escape any ancestor stacking context (e.g. sticky header)
    const img = $("[data-lightbox-img]", box);
    let lastFocus = null;

    const open = (el) => {
      const full = el.dataset.full || el.querySelector("img")?.src;
      if (!full) return; // e.g. hero currently showing a video, nothing to zoom
      img.src = full;
      img.alt = el.querySelector("img")?.alt || "";
      lastFocus = el;
      box.hidden = false;
      document.body.style.overflow = "hidden";
      $("[data-lightbox-close]", box).focus();
    };
    const close = () => {
      box.hidden = true;
      img.src = "";
      document.body.style.overflow = "";
      lastFocus?.focus();
    };

    triggers.forEach((el) => {
      el.addEventListener("click", () => open(el));
      el.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); open(el); }
      });
    });
    box.addEventListener("click", (e) => { if (e.target === box) close(); });
    $("[data-lightbox-close]", box).addEventListener("click", close);
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !box.hidden) close(); });
  }

  function initBuyBox() {
    const box = $("[data-buy-box]");
    if (!box) return;
    const variants = JSON.parse($("[data-variant-json]", box).textContent);

    // Qty clamp 1–9
    const qtyWrap = $("[data-qty]", box);
    const qtyInput = qtyWrap && $("input", qtyWrap);
    qtyWrap?.addEventListener("click", (e) => {
      const b = e.target.closest("button[data-step]");
      if (!b) return;
      qtyInput.value = Math.min(9, Math.max(1, (+qtyInput.value || 1) + +b.dataset.step));
    });
    qtyInput?.addEventListener("change", () => {
      qtyInput.value = Math.min(9, Math.max(1, +qtyInput.value || 1));
    });

    // Variant chips
    const groups = $$("[data-option-group]", box);
    const selected = groups.map((g) => $(".pdp-chip.is-selected", g)?.dataset.value);
    const notifyVariantChange = (v) => {
      const input = $("[data-variant-id]", box);
      const form = input?.closest("form");

      // App blocks such as Afterpay messaging usually listen for the native
      // variant input/form change rather than this theme's custom chip click.
      input?.dispatchEvent(new Event("input", { bubbles: true }));
      input?.dispatchEvent(new Event("change", { bubbles: true }));
      form?.dispatchEvent(new Event("change", { bubbles: true }));

      // Keep legacy/script-snippet integrations in step with the custom PDP.
      window.afterpay_current_variant = { id: v.id, price: v.price };
      document.dispatchEvent(new CustomEvent("variant:change", { detail: { variant: v } }));
      document.dispatchEvent(new CustomEvent("product:variant-change", { detail: { variant: v } }));
      document.dispatchEvent(new CustomEvent("pdp:variant", { detail: v }));
    };
    const render = (v) => {
      if (!v) return;
      $("[data-variant-id]", box).value = v.id;
      $("[data-price]", box).textContent = money(v.price);
      const cmp = $("[data-compare]", box), pill = $("[data-save-pill]", box);
      const onSale = v.compare_at_price > v.price;
      cmp.hidden = pill.hidden = !onSale;
      if (onSale) { cmp.textContent = money(v.compare_at_price); pill.textContent = "Save " + money(v.compare_at_price - v.price); }
      $("[data-instalments]", box).textContent =
        "or 4 × " + money(Math.round(v.price / 4)) + " interest-free · Afterpay / Zip";
      const stock = $("[data-stock]", box);
      // Made-to-order products carry a fixed availability note instead of a
      // stock count; textContent since it comes from a metafield.
      const availNote = stock.dataset.availabilityNote;
      if (availNote) stock.textContent = availNote;
      else stock.innerHTML = v.available
        ? "In stock" + (v.inventory_managed && v.inventory_quantity > 0 && v.inventory_quantity < 10
            ? " · <strong>" + v.inventory_quantity + " left</strong>" : "")
        : "Out of stock";
      const atc = $("[data-atc]", box);
      atc.disabled = !v.available;
      atc.textContent = v.available ? "Add to cart" : "Sold out";
      notifyVariantChange(v);
    };
    groups.forEach((g, gi) =>
      g.addEventListener("click", (e) => {
        const chip = e.target.closest("[data-chip]");
        if (!chip) return;
        selected[gi] = chip.dataset.value;
        $$(".pdp-chip", g).forEach((c) => {
          c.classList.toggle("is-selected", c === chip);
        });
        render(variants.find((v) => v.options.every((o, i) => o === selected[i])));
      })
    );
  }

  function initPostcodeChecker() {
    const box = $("[data-postcode-checker]");
    if (!box) return;
    const zones = JSON.parse($("[data-postcode-zones]", box).textContent);
    const isMetro = (pc) => {
      const n = +pc;
      return zones.some((z) => {
        const [lo, hi] = z.split("-").map(Number);
        return hi ? n >= lo && n <= hi : n === lo;
      });
    };
    const input = $("[data-postcode-input]", box);
    const result = $("[data-postcode-result]", box);
    const check = () => {
      const pc = input.value.trim();
      result.classList.remove("is-quote");
      if (!/^\d{4}$/.test(pc)) {
        result.textContent = "Enter a valid 4-digit postcode.";
        return;
      }
      if (isMetro(pc)) {
        result.innerHTML = "<strong>" + money(+box.dataset.rateCents) + " " + box.dataset.rateName +
          "</strong> to " + pc + ".";
      } else {
        const chatUrl = box.dataset.chatUrl;
        result.classList.add("is-quote");
        result.innerHTML = "Outside our flat-rate delivery area — " +
          (chatUrl ? '<a class="pdp-link" href="' + chatUrl + '">request a delivery quote</a>' : "contact us for a delivery quote") +
          " and we&rsquo;ll confirm the cost before you pay.";
      }
    };
    $("[data-postcode-check]", box).addEventListener("click", check);
    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") { e.preventDefault(); check(); }
    });
  }

  function initSticky() {
    const box = $("[data-buy-box]");
    const bar = $("[data-sticky-atc]");
    if (!box || !bar || !("IntersectionObserver" in window)) return;
    new IntersectionObserver(
      ([e]) => {
        const show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle("is-visible", show);
        bar.setAttribute("aria-hidden", String(!show));
        const stickyBtn = $("[data-sticky-atc-btn]", bar);
        if (stickyBtn) {
          if (show) stickyBtn.removeAttribute("tabindex");
          else stickyBtn.tabIndex = -1;
        }
      },
      { threshold: 0 }
    ).observe(box);
    document.addEventListener("pdp:variant", (e) => {
      const p = $("[data-sticky-price]", bar);
      if (p) p.textContent = money(e.detail.price);
      const btn = $("[data-sticky-atc-btn]", bar);
      if (btn) {
        btn.disabled = !e.detail.available;
        btn.textContent = e.detail.available ? "Add to cart" : "Sold out";
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    initGallery();
    initLightbox();
    initBuyBox();
    initPostcodeChecker();
    initSticky();
  });
  window.__pdp = { money, $, $$ }; // shared helpers for appended modules
})();
